import { DisplayPosition } from '@/common/manager/position/display-position';
import { componentMap as formComponentMap } from '@cainiaofe/cn-ui';
import { ButtonPosition } from '@/common/manager/position/button-position';
import { getButtonAction } from '@/common/manager/button';
const CnFormGrid = 'CnFormGrid';
export const config = {
    position: [DisplayPosition.formDialog, DisplayPosition.form],
    componentName: 'CnFormStepItem',
    formComponent: formComponentMap.CnFormStepItem,
    isFormContainer: true,
    allowParentList: ['root'],
    formItemBeforeHandler: (formItem, config) => {
        const { formItemConfig = {}, formProps = {}, state, _context, urlParams, formValue, formInstance, isDesign, formStepInstance, } = config || {};
        const { formStyle = {}, events } = formProps;
        const { cols } = formStyle || {};
        if (formItem) {
            const { label, name } = formItemConfig;
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                if (label && !componentProps.title) {
                    componentProps.title = label;
                }
                // 编辑态
                if (isDesign && typeof formStepInstance?.setCurrent === 'function') {
                    componentProps.onClick = (newCurrent) => {
                        formStepInstance.setCurrent(newCurrent);
                    };
                }
                // 运行态 CnFormStepItem onClick 事件，临时且不成熟的逻辑
                if (!isDesign && events?.length) {
                    const hasOnFormStepItemClickEvent = events.find((e) => e?.name === 'onFormStepItemClick');
                    if (hasOnFormStepItemClickEvent) {
                        componentProps.onClick = (stepIndex) => {
                            const { optType } = hasOnFormStepItemClickEvent;
                            if (['setFormFieldState'].includes(optType)) {
                                const action = getButtonAction({
                                    ...hasOnFormStepItemClickEvent,
                                    position: ButtonPosition.formEvent,
                                });
                                if (typeof action === 'function') {
                                    action({
                                        buttonConfig: {
                                            position: ButtonPosition.formEvent,
                                            options: hasOnFormStepItemClickEvent,
                                        },
                                        recordDataSource: formValue,
                                        state,
                                        _context,
                                        urlParams,
                                        formValue,
                                        formInstance,
                                        isDesign,
                                        formStepInstance,
                                    });
                                }
                            }
                            // const e = events[0];
                            // const ret = calculateTextExprValue(e?.current);
                            formStepInstance?.setCurrent(stepIndex);
                        };
                    }
                }
            }
            delete formItem['x-decorator'];
            formItem.properties = {};
            formItem.title = '';
            formItem.type = 'void';
            const { cols: cardCols } = componentProps;
            const formGridProps = {};
            if (cardCols) {
                formGridProps.cols = cardCols;
            }
            else {
                formGridProps.cols = cols;
            }
            formItem.properties = {
                [`${name}_${CnFormGrid}`]: {
                    type: 'void',
                    'x-component': CnFormGrid,
                    'x-component-props': formGridProps,
                    properties: {},
                },
            };
        }
    },
};
